import { Form } from 'react-bootstrap';
import 'styles/global.css';

/**
 * The standard Fusion text input field.
 * @param {{children: Component | Component[], style: Object, disabled?: boolean}}
 * @returns A react component
 */
export default function FusionCustomInput({
  children,
  style,
  disabled = false,
  label = '',
  className,
  required = false,
}) {
  return (
    <Form.Group>
      {label && (
        <Form.Label className="fs-6">
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </Form.Label>
      )}
      <div
        className={`fusion-input text-white ${className}`}
        style={{
          '--color': disabled ? 'grey' : '#325277',
          ...style,
        }}
      >
        {children}
      </div>
    </Form.Group>
  );
}
